export default data => ({
  name: data.name,
  lastname: data.lastname,
  patronymic: data.patronymic,
  phone: (data.phoneCode || "") + (data.phoneNumber || ""),
  birth_date: data.birthDate,
  email: data.email,
});
